import { Link } from "react-router-dom";
import Button from "./../../atoms/button/index.jsx";
import infoIcon from "resources/img/info-icon.svg";
import Seals from "components/atoms/seals/index.jsx";

import "./styles.scss";

const VehicleDetailActions = ({ vehicle }) => {
  return (
    <div className="vehicleDetailActions">
      <div className="container">
        <div className="message">
          <img src={infoIcon} alt="Reserva" />
          <div className="messageContent">
            <h4>Reserva online de forma rápida, fácil y segura.</h4>
            Pagas una seña de $50.000 con tu tarjeta de crédito hasta en 3
            cuotas.
          </div>
        </div>
        {vehicle.branch === "6" && (
          <div className="sealsContainer">
            <Seals />
          </div>
        )}
        <div className="buttons">
          <Link to={"/consultar/" + vehicle.id}>
            <Button buttonText="Consultar" />
          </Link>
          <Link to={"/reservar-usado/" + vehicle.id}>
            <Button buttonText="Comprar" type="secondary" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VehicleDetailActions;
